import React, { useEffect, useState, Suspense } from "react";
import "./App.css";
import { Canvas } from "@react-three/fiber";
import { EffectComposer, Bloom } from "@react-three/postprocessing";
import { Routes, Route, useLocation } from 'react-router-dom';

import Controls from "./UI/Controls/Controls";
import SceneManager from "./Scene/SceneManager/SceneManager";
import { Leva } from "leva";
import ModalManager from "./UI/Modals/ModalManager";
import { AdaptiveDpr, AdaptiveEvents, Preload } from "@react-three/drei";
import Login from "./UI/Login/Login";
import Admin from "./UI/Admin/Admin";
import Loader from "./Scene/Loader/Loader";
import TutorialModal from "./UI/Modals/TutorialModal/TutorialModal";
import StateIndicator from "./UI/StateIndicator/StateIndicator";
import { initGA, logPageView, logEvent, setUserEmail } from "./analytics";
import { useSelector, useDispatch } from 'react-redux';
import NewProductLanding from "./UI/NewProduct/NewProductLanding";
import { restoreSavedState } from "./store/reducers/progressionReducer";
// Composant pour la page principale
function MainPage() {
  const [showTutorial, setShowTutorial] = useState(false);
  const dispatch = useDispatch();
  const savedState = useSelector((state) => state.progression?.savedState);
  const token = useSelector((state) => state.progression?.token);
  const [hasRestored, setHasRestored] = useState(false);

  const handleCloseTutorial = () => {
    setShowTutorial(false);
  };

  // Restaurer l'état sauvegardé et s'assurer que le scroll est débloqué
  useEffect(() => {
    document.body.style.overflow = '';
    window.scrollTo(0, 0);
    
    console.log("🏠 MainPage mounted - état:", { savedState, token: !!token, hasRestored });
    
    // Si on a un état sauvegardé ET un token, le restaurer une seule fois
    if (savedState && token && !hasRestored) {
      console.log("📦 Restauration de l'état sauvegardé:", savedState);
      dispatch(restoreSavedState());
      setHasRestored(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedState, token]); // Dépendre de savedState et token

  return (
    <>
      <div className="App">
        <Leva collapsed={false} />
        <Suspense fallback={
          <div>
            <h1>Loading...</h1>
          </div>
        }>
          <Canvas >
            <AdaptiveDpr pixelated />
            <AdaptiveEvents />
            <SceneManager></SceneManager>
          </Canvas>
        </Suspense>
      </div>
      <Controls></Controls>
      <ModalManager></ModalManager>
      <StateIndicator />
      <button
        className="help-button"
        onClick={() => {
          setShowTutorial(true);
          logEvent('ui_interaction', 'help_button_click');
        }}
      >
        ?
      </button>
      {showTutorial && <TutorialModal onClose={handleCloseTutorial} />}
      <Login />
    </>
  );
}

// Composant pour suivre les changements de route
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
}

function App() {
  const userEmail = useSelector((state) => state.progression.userEmail);

  useEffect(() => {
    // Initialiser GTM
    initGA();
    // Premier pageview
    logPageView();
    
    // Si l'utilisateur est déjà connecté (email dans le store), initialiser le filtre
    if (userEmail) {
      setUserEmail(userEmail);
    }
  }, [userEmail]);

  return (
    <>
      {/* <Loader /> */}
      <RouteTracker />
      <Routes>
        <Route path="/update-password" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/new-product" element={<NewProductLanding />} />
        <Route path="/" element={<MainPage />} />
      </Routes>
    </>
  );
}

export default App;
